<script>
  import AppPageHeader from '../../../components/main/PageHeader'
  import EmptyList from '../../../components/list/EmptyList'

  import * as restfulService from '../../../services/restfulService'
  import * as $contratoService from '../services/contratoService'

  import bus from '@utils/bus'
  import {mapGetters} from 'vuex'

  import {isEmpty} from 'lodash'

  export default {
    components: {AppPageHeader, EmptyList},
    mounted () {
      this.carregarContratos()
    },
    data () {
      return {
        contrato: null,
        periodo: null,
        contratos: [],
        periodos: [],
        horarios: []
      }
    },
    computed: {
      ...mapGetters(['currentUser']),
      horariosVazio: function () {
        return isEmpty(this.horarios)
      },
      possuiDisciplinaIntensiva: function () {
        return this.horarios.some(item => item.hasOwnProperty(8))
      },
      possuiDisciplinaDistancia: function () {
        return this.horarios.some(item => item.hasOwnProperty(9))
      },
      possuiDisciplinaEstagio: function () {
        return this.horarios.some(item => item.hasOwnProperty(10))
      },
      possuiDisciplinaPeriodoEspecial: function () {
        return this.horarios.some(item => item.hasOwnProperty(11))
      }
    },
    methods: {
      carregarContratos () {
        $contratoService.buscarContratos()
          .then((response) => {
            this.contratos = [...this.contratos, ...response]
            if (this.contratos.length === 1) {
              this.contrato = this.contratos[0].id
              this.selecionaContrato(this.contrato)
            } else {
              bus.$emit('hide-loader')
            }
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      selecionaContrato (value) {
        this.periodo = null
        this.periodos.splice(0)
        this.horarios.splice(0)
        if (value) {
          bus.$emit('show-loader')
          $contratoService.buscarPeriodos(value)
            .then((response) => {
              this.periodos = [...this.periodos, ...response]
              if (this.periodos.length > 0) {
                this.periodo = this.periodos[0].periodo
                this.selecionaPeriodo(this.periodo)
              }
              bus.$emit('hide-loader')
            })
            .catch(e => {
              bus.$emit('hide-loader')
              console.log(e)
            })
        }
      },
      selecionaPeriodo (value) {
        if (value) {
          bus.$emit('show-loader')
          this.horarios.splice(0)
          let data = {periodo: value}
          restfulService.post('contrato', 'horarios', this.contrato, data)
            .then((response) => {
              this.horarios = [...this.horarios, ...response]
              bus.$emit('hide-loader')
            })
            .catch(e => {
              bus.$emit('hide-loader')
              console.log(e)
            })
        } else {
          this.horarios.splice(0)
        }
      }
    }
  }
</script>

<template>
    <div class="page-content">
        <app-page-header/>
        <div class="box">
            <v-container fluid grid-list-md>
                <v-layout row wrap>
                    <v-flex sm6 xs12>
                        <v-select :items="contratos"
                                  v-model="contrato"
                                  label="Curso"
                                  no-data-text="Nenhum curso encontrado"
                                  clearable
                                  @input="selecionaContrato"
                                  item-value="id"
                                  item-text="descricao"/>
                    </v-flex>
                    <v-flex sm6 xs12>
                        <v-select :items="periodos"
                                  v-model="periodo"
                                  label="Período"
                                  no-data-text="Nenhum períodos encontrado"
                                  clearable
                                  @input="selecionaPeriodo"
                                  item-value="periodo"
                                  item-text="descricao"/>
                    </v-flex>
                </v-layout>
            </v-container>
            <empty-list v-if="horariosVazio"
                        title="Selecione o Curso/Período"
                        description="O horário será mostrado conforme o período selecionado"/>
            <div v-if="!horariosVazio">
                <h3 class="page-content-title">Horário</h3>
                <div class="responsive-table">
                    <table class="v-table">
                        <thead>
                        <tr>
                            <th>Horário</th>
                            <th v-if="possuiDisciplinaIntensiva">Intensivo</th>
                            <th v-if="possuiDisciplinaDistancia">Distancia</th>
                            <th v-if="possuiDisciplinaEstagio">Estágio</th>
                            <th v-if="possuiDisciplinaPeriodoEspecial">Regime Especial</th>
                            <th>Segunda-Feira</th>
                            <th>Terça-Feira</th>
                            <th>Quarta-Feira</th>
                            <th>Quinta-Feira</th>
                            <th>Sexta-Feira</th>
                            <th>Sábado</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in horarios">
                            <td><strong>{{item.hora}}</strong></td>
                            <td v-if="possuiDisciplinaIntensiva">{{item['8'] ? item['8'].disciplina : ''}}</td>
                            <td v-if="possuiDisciplinaDistancia">{{item['9'] ? item['9'].disciplina : ''}}</td>
                            <td v-if="possuiDisciplinaEstagio">{{item['10'] ? item['10'].disciplina : ''}}</td>
                            <td v-if="possuiDisciplinaPeriodoEspecial">{{item['11'] ? item['11'].disciplina : ''}}</td>
                            <td>{{item['2'] ? item['2'].disciplina : ''}}</td>
                            <td>{{item['3'] ? item['3'].disciplina : ''}}</td>
                            <td>{{item['4'] ? item['4'].disciplina : ''}}</td>
                            <td>{{item['5'] ? item['5'].disciplina : ''}}</td>
                            <td>{{item['6'] ? item['6'].disciplina : ''}}</td>
                            <td>{{item['7'] ? item['7'].disciplina : ''}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.v-table .regime {
  clear: both;
  font-size: 10px;
  font-weight: bold;
}
</style>




// WEBPACK FOOTER //
// GradeHorarios.vue?356f12a6